import React from 'react';
import Grid from '../layout/grid';
import { DateTime } from 'luxon';

export default props => {

	let value = null;
	if (props.value) {
		value = DateTime.fromFormat(props.value, 'yyyy/LL/dd HH:mm').toFormat("yyyy-LL-dd'T'HH:mm");

		if (!value || value == 'Invalid DateTime') {
			value = DateTime.fromISO(props.value).toFormat("yyyy-LL-dd'T'HH:mm");
		}
	}
	
	return (
		<Grid cols={props.cols} style={{ minWidth: 220, maxWidth: 220 }}>
			<div className='form-group' style={{ marginBottom: props.marginBottom }}>
				{props.label && (
					<label htmlFor={props.name}>{props.label}</label>
				)}
				<input
					{...props.input}
					className='form-control'
					style={{ fontSize: props.fontSize }}
					placeholder={props.placeholder}
					readOnly={props.readOnly}
					type='datetime-local'
					value={value}
					onChange={e => {
						props.onChange(e.target.value ? DateTime.fromISO(e.target.value).toFormat('yyyy/MM/dd HH:mm') : null);
					}}
				/>
			</div>
		</Grid>
	);
};
